import React from 'react'
import Container from '@material-ui/core/Container';

import moment from 'moment';

import IntlMessage from '../../../../LocaleEngine';

import './index.scss';

export default ({data}) => {
    let socketLogo = "https://ik.imagekit.io/spotlio/spotlio_logo_footer_lWnHP6tqs.png";
    if(data && data.assets && data.assets.socket && data.assets.socket.logo) {
        socketLogo = data.assets.socket.logo;
    }

    return (
    <div className="socketWrapper">
        <Container className="container" maxWidth="lg">
            <div className="poweredBySpotlio">
                <span><IntlMessage id="skin.global.poweredby" /></span>
                <a rel="noopener noreferrer nofollow" target="_blank" href="https://www.spotlio.com/">
                    <img alt="Powered By SPOTLIO" src={socketLogo} />
                </a>
            </div>
            <div className="buildVersion">
                <span>v{moment.utc(parseInt(global.appVersion)).format('YYYYMMDDHHmmss')}</span>
            </div>
        </Container>
    </div>
    )
};
